// extracted by css-extract-rspack-plugin
export default {"alert":"InstagramSearchSelectionDownload-module__alert--TwTJ8"};